import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "row": "campaign-page-92461c5b-row-WXUgJq",
  "wideGridContainer": "campaign-page-92461c5b-wideGridContainer-WXUgJq",
  "tinyOffset10": "campaign-page-92461c5b-tinyOffset10-WXUgJq",
  "wide10": "campaign-page-92461c5b-wide10-WXUgJq",
  "wideOffset7": "campaign-page-92461c5b-wideOffset7-WXUgJq",
  "wide3": "campaign-page-92461c5b-wide3-WXUgJq",
  "wide12": "campaign-page-92461c5b-wide12-WXUgJq",
  "xwide11": "campaign-page-92461c5b-xwide11-WXUgJq",
  "tiny9": "campaign-page-92461c5b-tiny9-WXUgJq",
  "default2": "campaign-page-92461c5b-default2-WXUgJq",
  "confined11": "campaign-page-92461c5b-confined11-WXUgJq",
  "tinyOffset2": "campaign-page-92461c5b-tinyOffset2-WXUgJq",
  "confined8": "campaign-page-92461c5b-confined8-WXUgJq",
  "wide1": "campaign-page-92461c5b-wide1-WXUgJq",
  "xwideOffset6": "campaign-page-92461c5b-xwideOffset6-WXUgJq",
  "default0": "campaign-page-92461c5b-default0-WXUgJq",
  "defaultOffset1": "campaign-page-92461c5b-defaultOffset1-WXUgJq",
  "tiny5": "campaign-page-92461c5b-tiny5-WXUgJq",
  "tiny10": "campaign-page-92461c5b-tiny10-WXUgJq",
  "tinyOffset0": "campaign-page-92461c5b-tinyOffset0-WXUgJq",
  "wideOffset0": "campaign-page-92461c5b-wideOffset0-WXUgJq",
  "wideOffset5": "campaign-page-92461c5b-wideOffset5-WXUgJq",
  "standardGridContainer": "campaign-page-92461c5b-standardGridContainer-WXUgJq",
  "wideOffset11": "campaign-page-92461c5b-wideOffset11-WXUgJq",
  "xwide6": "campaign-page-92461c5b-xwide6-WXUgJq",
  "xwide8": "campaign-page-92461c5b-xwide8-WXUgJq",
  "wide2": "campaign-page-92461c5b-wide2-WXUgJq",
  "col": "campaign-page-92461c5b-col-WXUgJq",
  "defaultOffset7": "campaign-page-92461c5b-defaultOffset7-WXUgJq",
  "confinedOffset0": "campaign-page-92461c5b-confinedOffset0-WXUgJq",
  "xwide0": "campaign-page-92461c5b-xwide0-WXUgJq",
  "defaultOffset8": "campaign-page-92461c5b-defaultOffset8-WXUgJq",
  "xwide12": "campaign-page-92461c5b-xwide12-WXUgJq",
  "wideOffset8": "campaign-page-92461c5b-wideOffset8-WXUgJq",
  "wide9": "campaign-page-92461c5b-wide9-WXUgJq",
  "armstrongGridContainer": "campaign-page-92461c5b-armstrongGridContainer-WXUgJq",
  "default12": "campaign-page-92461c5b-default12-WXUgJq",
  "confinedOffset2": "campaign-page-92461c5b-confinedOffset2-WXUgJq",
  "confinedOffset7": "campaign-page-92461c5b-confinedOffset7-WXUgJq",
  "wideOffset9": "campaign-page-92461c5b-wideOffset9-WXUgJq",
  "confined3": "campaign-page-92461c5b-confined3-WXUgJq",
  "default4": "campaign-page-92461c5b-default4-WXUgJq",
  "xwide2": "campaign-page-92461c5b-xwide2-WXUgJq",
  "grid": "campaign-page-92461c5b-grid-WXUgJq",
  "confined6": "campaign-page-92461c5b-confined6-WXUgJq",
  "tiny2": "campaign-page-92461c5b-tiny2-WXUgJq",
  "wide7": "campaign-page-92461c5b-wide7-WXUgJq",
  "xwideOffset8": "campaign-page-92461c5b-xwideOffset8-WXUgJq",
  "wideOffset3": "campaign-page-92461c5b-wideOffset3-WXUgJq",
  "xwide4": "campaign-page-92461c5b-xwide4-WXUgJq",
  "tiny0": "campaign-page-92461c5b-tiny0-WXUgJq",
  "tiny6": "campaign-page-92461c5b-tiny6-WXUgJq",
  "xwide3": "campaign-page-92461c5b-xwide3-WXUgJq",
  "confined12": "campaign-page-92461c5b-confined12-WXUgJq",
  "xwideOffset3": "campaign-page-92461c5b-xwideOffset3-WXUgJq",
  "default1": "campaign-page-92461c5b-default1-WXUgJq",
  "confined7": "campaign-page-92461c5b-confined7-WXUgJq",
  "xwideOffset5": "campaign-page-92461c5b-xwideOffset5-WXUgJq",
  "defaultOffset3": "campaign-page-92461c5b-defaultOffset3-WXUgJq",
  "wide8": "campaign-page-92461c5b-wide8-WXUgJq",
  "tiny7": "campaign-page-92461c5b-tiny7-WXUgJq",
  "defaultOffset4": "campaign-page-92461c5b-defaultOffset4-WXUgJq",
  "confined10": "campaign-page-92461c5b-confined10-WXUgJq",
  "tiny8": "campaign-page-92461c5b-tiny8-WXUgJq",
  "xwide9": "campaign-page-92461c5b-xwide9-WXUgJq",
  "xwide10": "campaign-page-92461c5b-xwide10-WXUgJq",
  "xwideOffset0": "campaign-page-92461c5b-xwideOffset0-WXUgJq",
  "default3": "campaign-page-92461c5b-default3-WXUgJq",
  "tiny12": "campaign-page-92461c5b-tiny12-WXUgJq",
  "confinedOffset10": "campaign-page-92461c5b-confinedOffset10-WXUgJq",
  "xwideOffset11": "campaign-page-92461c5b-xwideOffset11-WXUgJq",
  "tiny4": "campaign-page-92461c5b-tiny4-WXUgJq",
  "wideOffset2": "campaign-page-92461c5b-wideOffset2-WXUgJq",
  "wideOffset6": "campaign-page-92461c5b-wideOffset6-WXUgJq",
  "default9": "campaign-page-92461c5b-default9-WXUgJq",
  "gridContainer": "campaign-page-92461c5b-gridContainer-WXUgJq",
  "tinyOffset9": "campaign-page-92461c5b-tinyOffset9-WXUgJq",
  "confined4": "campaign-page-92461c5b-confined4-WXUgJq",
  "xwideOffset9": "campaign-page-92461c5b-xwideOffset9-WXUgJq",
  "confinedOffset8": "campaign-page-92461c5b-confinedOffset8-WXUgJq",
  "tinyOffset1": "campaign-page-92461c5b-tinyOffset1-WXUgJq",
  "confinedOffset4": "campaign-page-92461c5b-confinedOffset4-WXUgJq",
  "wide0": "campaign-page-92461c5b-wide0-WXUgJq",
  "tinyOffset4": "campaign-page-92461c5b-tinyOffset4-WXUgJq",
  "xwideOffset4": "campaign-page-92461c5b-xwideOffset4-WXUgJq",
  "defaultOffset11": "campaign-page-92461c5b-defaultOffset11-WXUgJq",
  "default7": "campaign-page-92461c5b-default7-WXUgJq",
  "xwideOffset7": "campaign-page-92461c5b-xwideOffset7-WXUgJq",
  "wide11": "campaign-page-92461c5b-wide11-WXUgJq",
  "confined9": "campaign-page-92461c5b-confined9-WXUgJq",
  "defaultOffset2": "campaign-page-92461c5b-defaultOffset2-WXUgJq",
  "default11": "campaign-page-92461c5b-default11-WXUgJq",
  "wide5": "campaign-page-92461c5b-wide5-WXUgJq",
  "tinyOffset6": "campaign-page-92461c5b-tinyOffset6-WXUgJq",
  "confined5": "campaign-page-92461c5b-confined5-WXUgJq",
  "confinedOffset1": "campaign-page-92461c5b-confinedOffset1-WXUgJq",
  "tinyOffset11": "campaign-page-92461c5b-tinyOffset11-WXUgJq",
  "wideOffset10": "campaign-page-92461c5b-wideOffset10-WXUgJq",
  "wideOffset4": "campaign-page-92461c5b-wideOffset4-WXUgJq",
  "confinedOffset9": "campaign-page-92461c5b-confinedOffset9-WXUgJq",
  "wideOffset1": "campaign-page-92461c5b-wideOffset1-WXUgJq",
  "wide4": "campaign-page-92461c5b-wide4-WXUgJq",
  "xwideOffset2": "campaign-page-92461c5b-xwideOffset2-WXUgJq",
  "xwideOffset10": "campaign-page-92461c5b-xwideOffset10-WXUgJq",
  "default8": "campaign-page-92461c5b-default8-WXUgJq",
  "default5": "campaign-page-92461c5b-default5-WXUgJq",
  "tinyOffset3": "campaign-page-92461c5b-tinyOffset3-WXUgJq",
  "confinedOffset3": "campaign-page-92461c5b-confinedOffset3-WXUgJq",
  "confinedOffset11": "campaign-page-92461c5b-confinedOffset11-WXUgJq",
  "confined0": "campaign-page-92461c5b-confined0-WXUgJq",
  "confined2": "campaign-page-92461c5b-confined2-WXUgJq",
  "tinyOffset5": "campaign-page-92461c5b-tinyOffset5-WXUgJq",
  "confined1": "campaign-page-92461c5b-confined1-WXUgJq",
  "xwide7": "campaign-page-92461c5b-xwide7-WXUgJq",
  "tiny3": "campaign-page-92461c5b-tiny3-WXUgJq",
  "tiny11": "campaign-page-92461c5b-tiny11-WXUgJq",
  "defaultOffset6": "campaign-page-92461c5b-defaultOffset6-WXUgJq",
  "defaultOffset9": "campaign-page-92461c5b-defaultOffset9-WXUgJq",
  "confinedOffset5": "campaign-page-92461c5b-confinedOffset5-WXUgJq",
  "xwide5": "campaign-page-92461c5b-xwide5-WXUgJq",
  "tiny1": "campaign-page-92461c5b-tiny1-WXUgJq",
  "confinedOffset6": "campaign-page-92461c5b-confinedOffset6-WXUgJq",
  "xwideOffset1": "campaign-page-92461c5b-xwideOffset1-WXUgJq",
  "defaultOffset5": "campaign-page-92461c5b-defaultOffset5-WXUgJq",
  "xwide1": "campaign-page-92461c5b-xwide1-WXUgJq",
  "defaultOffset10": "campaign-page-92461c5b-defaultOffset10-WXUgJq",
  "default6": "campaign-page-92461c5b-default6-WXUgJq",
  "default10": "campaign-page-92461c5b-default10-WXUgJq",
  "wide6": "campaign-page-92461c5b-wide6-WXUgJq",
  "tinyOffset7": "campaign-page-92461c5b-tinyOffset7-WXUgJq",
  "tinyOffset8": "campaign-page-92461c5b-tinyOffset8-WXUgJq"
};